module.exports = __webpack_public_path__ + "img/story1_0.b2e96a4f.png";